import { IconStylingModel } from '../models/icon/icon-styling.model';
import { InputModel } from '../models/input/input.model';
import { InputStylingModel } from '../models/input/input-styling.model';
import { DatatableFilterModel } from '../models/datatable/datatable-filter.model';
import { DatatableFilterStylingModel } from '../models/datatable/datatable-filter-styling.model';

export const /** @type {?} */ DatatableFilterTemplates = {
  defaultTemplate: {
    property: new DatatableFilterModel({
      display: true,
      disable: false,
      inputProperty: new InputModel({
        display: true,
        disable: false,
        placeholder: 'Filter',
        iconProperty: {
          display: true,
          disable: false,
          name: 'filter_list',
          size: '20px'
        }
      })
    }),
    style: new DatatableFilterStylingModel({
      inputStyling: new InputStylingModel({
        iconStyling: new IconStylingModel({ icon: { themeColor: 'primary' } })
      })
    })
  }
}
